import React from 'react'
import PropTypes from 'prop-types'

const ModalLink = ({
    ClassName,
    LinkText,
    SrText,
    ToggleModal
}) => {

    return (
        <div>
            <button className='btn btn-icon color-red p-0 d-flex align-items-center' onClick={e => {
                e.preventDefault()
                ToggleModal(true)
            }}>
                <span className={ClassName}/>
                <span className="sr-only">{SrText}</span>
                <span>&nbsp;{LinkText}</span>
            </button>
        </div>
    );
};

ModalLink.propType = {
    ClassName: PropTypes.string,
    LinkText: PropTypes.string.isRequired,
    ToggleModal: PropTypes.func.isRequired
};

export default ModalLink;